function TrackingContainer() {
  return <div data-testid="trackingContainer" />;
}

export default TrackingContainer;
